import { IApiResponse, IPageKeyword } from "../models/Interfaces";
import { BaseService } from "./BaseService";

export class KeywordService extends BaseService {

  public getPageKeywords = async (pageid: number, strict: boolean = false) : Promise<Array<IPageKeyword>> => {
    if (this.siteKey && pageid) {
      const url: string = `/SiteAdmin/GetPageKeyword/${this.siteKey}/${pageid}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res?.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve keyword data");
          if (strict) throw new Error("Unable to load page keywords");
        }
      }
    }
    return [];
  }

  public saveKeyword = async (keyword: IPageKeyword) : Promise<IPageKeyword | null> => {
    if (this.siteKey && keyword) {
      const url: string = `/SiteAdmin/AddUpdatePageKeyword`;
      const res = await this._ajaxService.Post<IApiResponse>(url, keyword, true);
      
      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        this.EmitDataError(res, "Failed to save keyword details");
      }
    }
    return null;
  }

  public deleteKeyword = async (keywordid: number, pageid: number) : Promise<boolean> => {
    if (this.siteKey && keywordid && pageid) {
      const url: string = `/SiteAdmin/DeletePageKeyword/${this.siteKey}/${keywordid}/${pageid}`;
      const res = await  this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200) {
        return true;
      } else {
        this.EmitDataError(res, "Failed to remove keyword from page");
      }
    }
    return false;
  }

  public newKeyword = (pageid: number) : IPageKeyword | null => {
    if (this.siteKey) {
      return {
        PageId: pageid,
        SiteId: this.siteKey,
        Keyword: "",
        Id: 0
      };
    } else {
      return null;
    }
  }
}